/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PurchaseDeliveryTarget = {
  Purchaser: "PURCHASER",
  Recipient: "RECIPIENT",
} as const;

export type PurchaseDeliveryTarget =
  (typeof PurchaseDeliveryTarget)[keyof typeof PurchaseDeliveryTarget];

export type PurchaseDeliveryTargetEnumType = typeof PurchaseDeliveryTarget;
export type PurchaseDeliveryTargetOptional = PurchaseDeliveryTarget;
export type PurchaseDeliveryTargetTrackedI = PurchaseDeliveryTarget;
export type PurchaseDeliveryTargetTracked = PurchaseDeliveryTarget;
export type PurchaseDeliveryTargetMetaI = EnumMetaType<
  PurchaseDeliveryTargetEnumType,
  PurchaseDeliveryTarget
>;
export const PurchaseDeliveryTargetMeta = typeMetaEnum<
  PurchaseDeliveryTargetEnumType,
  PurchaseDeliveryTarget
>("PurchaseDeliveryTarget", PurchaseDeliveryTarget);
export function transformDatesPurchaseDeliveryTarget(
  model: PurchaseDeliveryTarget,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
